import { createSlice } from "@reduxjs/toolkit";
import {
  addOrder,
  getOrders,
  getFamilyOrders,
  editOrder,
  deleteOrder,
  getOrdersCounter
} from "./thunk";

const initialState = {
  orders: [],
  ordersCounter:null,
  familyOrders: [],
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "orderSlice",
  initialState,
  reducers: {
    clearResponses: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {

    // Get cart
    builder
      .addCase(getOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.loading = false;
        // assume action.payload.data contains array of cart items
        state.orders = action.payload;
      })
      .addCase(getOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    // Get cart for family
    builder
      .addCase(getFamilyOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFamilyOrders.fulfilled, (state, action) => {
        state.loading = false;
        // assume action.payload.data contains array of family cart items
        state.familyOrders = action.payload;
      })
      .addCase(getFamilyOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

    builder
      .addCase(editOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editOrder.fulfilled, (state, action) => {
        state.loading = false;
        const updatedItem = action.payload;
        const index = state.familyOrders.findIndex(
          (item) => item.id === updatedItem.id
        );
        if (index !== -1) state.familyOrders[index] = updatedItem;
      })
      .addCase(editOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });

      builder.addCase(getOrdersCounter.fulfilled, (state, action) => {
        state.loading = false;
        // assume action.payload.data contains array of cart items
        state.ordersCounter = action.payload;
      })
    // Delete cart item
    builder
      .addCase(deleteOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(deleteOrder.fulfilled, (state, action) => {
  state.loading = false;
  const deletedId = action.meta.arg.id;
  if (Array.isArray(state.familyOrders)) {
    state.familyOrders.families = state?.familyOrders?.families?.filter(item => item?.id !== deletedId);
  } 
})

      .addCase(deleteOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error;
      });
  },
});

export const { clearResponses } = orderSlice.actions;
export default orderSlice.reducer;
